import { httpClient } from "@bw/shared/api";
import type { AuditEntryResponse } from "@bw/shared/types";

export interface AuditLogParams {
  actor_id?: string;
  action?: string;
  resource_type?: string;
  resource_id?: string;
  since?: string;
  until?: string;
  limit?: number;
  offset?: number;
}

export async function queryAuditLog(
  params?: AuditLogParams,
): Promise<{ entries: AuditEntryResponse[]; total: number }> {
  const sp = new URLSearchParams();
  if (params?.actor_id) sp.set("actor_id", params.actor_id);
  if (params?.action) sp.set("action", params.action);
  if (params?.resource_type) sp.set("resource_type", params.resource_type);
  if (params?.resource_id) sp.set("resource_id", params.resource_id);
  if (params?.since) sp.set("since", params.since);
  if (params?.until) sp.set("until", params.until);
  if (params?.limit !== undefined) sp.set("limit", String(params.limit));
  if (params?.offset !== undefined) sp.set("offset", String(params.offset));
  const qs = sp.toString();
  return httpClient.get<{ entries: AuditEntryResponse[]; total: number }>(
    `/audit${qs ? `?${qs}` : ""}`,
  );
}
